module.exports = __webpack_public_path__ + "static/img/mabangerp.e66905ff.png";